import * as ToggleGroup from '@radix-ui/react-toggle-group';
import clsx from 'clsx';

export interface SegmentOption<T extends string> {
  readonly value: T;
  readonly label: string;
}

export interface SegmentedControlProps<T extends string> {
  readonly options: readonly SegmentOption<T>[];
  readonly value: T;
  readonly onValueChange: (value: T) => void;
  readonly label: string;
  readonly className?: string;
}

export function SegmentedControl<T extends string>({
  options, value, onValueChange, label, className,
}: SegmentedControlProps<T>) {
  return (
    <ToggleGroup.Root
      type="single"
      value={value}
      onValueChange={(v) => { if (v) onValueChange(v as T); }}
      aria-label={label}
      className={clsx('et-seg', className)}
    >
      {options.map((o) => (
        <ToggleGroup.Item key={o.value} value={o.value} className="et-seg__item">
          {o.label}
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
}
